// No site não há compra: a assinatura é feita no app (Google Play ou App Store) e vale aqui também,
// porque o servidor guarda as abas assinadas na tabela assinaturas_loja (0.64).
import { RC_ANDROID, RC_IOS } from './config';

export const MODO_TESTE = !RC_ANDROID && !RC_IOS;
export const lojaDisponivel = () => false;
export const appSemLoja = () => false;
export const produtoDe = (aba: string) => (aba === 'planner' ? 'myplanner_basico_anual' : `myplanner_${aba}_anual`);
export function abaDoProduto(p: string): string | null {
  const m = /^myplanner_([a-z0-9]+)_anual/.exec(p ?? '');
  return m ? (m[1] === 'basico' ? 'planner' : m[1]) : null;
}
export const gerenciarUrl = 'https://play.google.com/store/account/subscriptions';
export const comprasLocais = (): Record<string, string> => ({});
export async function iniciarCompras(_u: string | null | undefined, _f: (m: Record<string, string>) => void) {}
export async function sairCompras() {}
export async function precosDaLoja(_a: string[]): Promise<Record<string, string>> { return {}; }
export type Resultado = { ok: true } | { ok: false; cancelou?: boolean; erro?: string };
export async function comprar(_a: string): Promise<Resultado> { return { ok: false, erro: 'web' }; }
export async function restaurar(): Promise<number> { return 0; }
export const aoComprar = (_f: () => void) => {};
